<template>
  <div class="h100-40 h-scroll">
    <ejs-grid
      ref="grid"
      :dataSource="dataForList"
      height="calc(100% - 0px)"
      :rowSelected="rowSelected"
      :rowDeselected="rowDeselected"
      :allowResizing="true"
      :allowPaging="true"

    >
      <e-columns>
        <e-column
          field="sysMeterTimelyTaskId"
          :headerText='$t("Pm.taskID")'
          textAlign="Center"
          width="7%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="sysMeterTimelyTaskName"
          :headerText='$t("Pm.taskName")'
          textAlign="Center"
          width="7%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="sysMeterTimelyStatus"
          :headerText='$t("Pm.taskState")'
          textAlign="Center"
          width="7%"
          clipMode="EllipsisWithTooltip"
          :formatter="sysMeterTimelyStatusFormat"
          :disableHtmlEncode="false"
        ></e-column>
        <e-column
          field="clientIp"
          headerText="IP"
          textAlign="Center"
          width="7%"
          clipMode="EllipsisWithTooltip"
          :formatter="clientIpFormat"
          :disableHtmlEncode="false"
          :visible = 'false'
        ></e-column>
        <e-column
          field="sysMeterTaskStatus"
          :headerText='$t("Pm.consistentState")'
          textAlign="Center"
          width="8%"
          clipMode="EllipsisWithTooltip"
          :formatter="taskStatusFormat"
        ></e-column>
        <e-column
          field="neType"
          :headerText='$t("Pm.resourceType")'
          textAlign="Center"
          width="7%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="sysMeterTimelyCycle"
          :headerText='$t("Pm.samplingPeriod_unit")'
          textAlign="Center"
          width="7%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="sysMeterTimelyTimeQuant"
          :headerText='$t("Pm.taskDuration_unit")'
          textAlign="Center"
          width="7%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="alarmCreateTime"
          :headerText='$t("Pm.taskEstablishTime")'
          textAlign="Center"
          width="7%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="meterRestStartTime"
          :headerText='$t("Pm.samplingStartTime")'
          textAlign="Center"
          width="7%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="meterRestEndTime"
          :headerText='$t("Pm.pauseTime")'
          textAlign="Center"
          width="9%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="chekStateTime"
          :headerText='$t("Pm.uniformityCheckTime")'
          textAlign="Center"
          width="9%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="alarmCreatePelope"
          :headerText='$t("Pm.createTaskUser")'
          textAlign="Center"
          width="5%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="remainTime"
          :headerText='$t("Pm.taskTimeRemaining_unit")'
          textAlign="Center"
          width="7%"
          clipMode="EllipsisWithTooltip"
          :formatter="remainTimeFormat"
          :disableHtmlEncode="false"
        ></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager
      ref="pager"
      @click="getRealTaskTableData(1)"
      :currentPage="page.currentPage"
      :pageCount="page.pageCount"
      :pageSize="page.pageSize"
      :totalRecordsCount="page.totalRecordsCount"
    ></ejs-pager>
  </div>
</template>

<script>
import commonUtil from './commonUtil';

import {
  Reorder,
  Resize,
  ExcelExport,
  Toolbar
} from '@syncfusion/ej2-vue-grids';


class baseParams {
  // this.page = { pageNo: 1, pageSize: 25 };
  constructor(page) {
    this.page = page;
    this.systemId = 1;
  }
}
class measureParams extends baseParams {
  constructor(counterTypeId, measureObjectTypeCode, neTypeId, pageParams) {
    super(pageParams);
    this.counterTypeId = counterTypeId;
    this.measureObjectTypeCode = measureObjectTypeCode;
    this.neTypeId = neTypeId;
  }
}
class neParams extends baseParams {
  constructor(neId, neTypeId, pageParams) {
    super(pageParams);
    this.neId = neId;
    this.neTypeId = neTypeId;
  }
}

export default {
  name: 'GridForTaskListReal',
  data() {
    return {
      page: {
        currentPage: 1,
        pageSize: 12,
        totalRecordsCount: 0,
        pageCount: 10
      },
      dataForList: [],
      remainSetInterval: [],
      remainTimer: undefined,
      serviceTime:0
    }
  },
  methods: {
    clientIpFormat(grids, data) {
      if (data.dataFlag == 1) {
        return '<font style="color:#5bf60e">' + data.clientIp + '</font>';
      } else {
        return '<font style="color:#cd0200">' + data.clientIp + '</font>';
      }
    },
    remainTimeFormat(grids, data) {
      let count = false;
      let result = this.computeTaskRemoteTime(data);
      let domDesc = '';
      if (result > 0) {
        domDesc = '<div id="remain-time' + data.sysMeterTimelyTaskId + '">' + result + '</div>';
        // 判断是否重复添加
        for (let index = 0; index < this.remainSetInterval.length; index++) {
          if (this.remainSetInterval[index].sysMeterTimelyTaskId == data.sysMeterTimelyTaskId) {
            count = true;
            break;
          }
        }
        if (!count) {
          this.remainSetInterval.push(data);
        }
      } else {
        if (data.sysMeterTimelyStatus != 2) {
          // 剩余时间为负数时，需要把状态置为失效
          this.setTaskUnavailable(data);
        }
        domDesc = 0;
      }
      // 启动定时器，只启动一次
      if (!this.remainTimer) {
        this.remainTimer = setInterval(this.remainCountDown, 1000);
      }
      return domDesc;
    },
    // 任务状态
    taskStatusFormat(grids, data) {
      let consistentStatus = [this.$t('Pm.inconsistent'), this.$t('Pm.consistent')];
      return consistentStatus[data.sysMeterTaskStatus];
    },
    /**
 * 计算任务的失剩余时间
 */
    computeTaskRemoteTime(taskRecord) {
      let result = 0;
      // 单位为s
      const taskTimeLength = taskRecord.sysMeterTimelyTimeQuant || 0;
      // 单位为ms
      const nowTime = Math.trunc(this.serviceTime/1000)*1000 || Date.parse(new Date()) || 0;
      // 单位为ms
      const createTaskTime = Date.parse(taskRecord.alarmCreateTime) || 0;

      result = taskTimeLength - (nowTime - createTaskTime) / 1000;
      if (result > taskTimeLength)
        result = taskTimeLength;
      return result;
    },
    // SetInterval调用的方法
    remainCountDown() {
      let result = 0;
      let deleteData = [];// 失效的数据
      let devElement = null;

      //从后台取到当前时间后，每隔1秒调用一次，当前时间+1，为了避免频繁向后台发起请求
      this.serviceTime = this.serviceTime + 1000;

      for (let index = 0; index < this.remainSetInterval.length; index++) {
        // 当数据被删除时也需要停止倒计时处理
        devElement = document.getElementById('remain-time' + this.remainSetInterval[index].sysMeterTimelyTaskId);
        if (!devElement) {
          deleteData.push(this.remainSetInterval[index]);
          continue;
        }

        // 计算剩余时间
        result = this.computeTaskRemoteTime(this.remainSetInterval[index]);

        if (result > 0) {
          devElement.innerHTML = result;
        } else {
          document.getElementById('remain-time' + this.remainSetInterval[index].sysMeterTimelyTaskId).innerHTML = 0;
          deleteData.push(this.remainSetInterval[index]);
          this.setTaskUnavailable(this.remainSetInterval[index])
        }
      }

      this.remainSetInterval = this.difference(this.remainSetInterval, deleteData);

      if (this.remainSetInterval.length === 0) {
        clearInterval(this.remainTimer);
        this.remainTimer = undefined;
      }
    },
    /**
   * 设置任务无效
   */
    setTaskUnavailable: async function (item) {
      const _this = this;
      const url = '/lte/pm/currenttime/taskmanagement/setTaskUnavailable';
      let params = {};
      params.systemId = 1;
      params.taskId = item.sysMeterTimelyTaskId;

      await this.$axios.get(url + commonUtil.analyticParameter(params), {}).then(response => {
        if (response.data.resultVal === 1) {
          _this.getRealTaskTableData(1);
        }
      });
    },
    // 返回两个数据的差集
    difference(arr1, arr2) {
      const set1 = new Set(arr1);
      const set2 = new Set(arr2);

      let subset = [];

      for (let item of set1) {
        if (!set2.has(item)) {
          subset.push(item);
        }
      }

      return subset;
    },
    rowSelected(msg) {
      this.rowData = msg.data;
      this.$emit('rowSelectedEmit', msg.data);
    },
    // 获取表格中已经选中的数据
    getRowData() {
      return this.rowData;
    },
    rowDeselected() {
      this.rowData = '';
    },
    sysMeterTimelyStatusFormat(grids, data) {
      let value = undefined;
      switch (data.sysMeterTimelyStatus) {
        case 0:
          value = this.setBackgroundColor('#f6900e', this.$t('Pm.pause'));
          break;
        case 1:
          value = this.setBackgroundColor('#5bf60e', this.$t('Pm.startUp'));
          break;
        case 2:
          value = this.setBackgroundColor('#cd0200', this.$t('Pm.failure'));
          break;
        default:
          value = data.sysMeterTimelyStatus;
      }
      return value;
    },
    /**
 * 设置背景颜色
 */
    setBackgroundColor(color, content) {
      return '<span style="background-color: ' + color + '; display: block; height: 28px; line-height: 28px;">' + content + '</span>';
    },
    // 加载表格数据
    getRealTaskTableData: async function(treeType, args) {
      let _this = this;
      let url = undefined;
      let params = undefined;
      let pageParams = {};

      _this.page.currentPage = _this.$refs.pager.ej2Instances.currentPage;
      pageParams.pageNo = _this.page.currentPage;
      pageParams.pageSize = _this.page.pageSize;

      if (treeType == 1) {
        url = '/lte/pm/currenttime/taskmanagement/listTaskByMeasureObject';
        if (!args) {
          args = { counterTypeId: '', measureObjectTypeCode: '', neTypeId: '' };
        }
        params = new measureParams(
          args.counterTypeId,
          args.measureObjectTypeCode,
          args.neTypeId,
          pageParams
        );
      } else {
        url = '/lte/pm/currenttime/taskmanagement/listTaskByNe.html';
        if (!args) {
          args = { neId: '', neTypeId: '' };
        }
        params = new neParams(args.neId, args.neTypeId, pageParams);
      }

         //请求后台的时间
      await this.$axios.get('/lte/pm/currenttime/taskmanagement/getCurrentSystemTime.html', {}).then(response => {
        _this.serviceTime = response.data;
      });

      this.$axios.post(url, params).then(response => {
        _this.dataForList = response.data.resultVal.result;
        _this.page.currentPage = response.data.resultVal.pageNo;
        _this.page.totalRecordsCount = response.data.resultVal.totalCount;
      });
    }
  },

  mounted() {
    this.getRealTaskTableData(1);
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, Toolbar]
  },
  destroyed() {

  },
  beforeDestroy() {
    // 倒计时清除定时器
    clearInterval(this.remainTimer);
    this.remainTimer = undefined;
  }
};
</script>

<style>
</style>
